import React from "react";
import { StyleSheet, css } from "aphrodite";
export default function GeneralProductDesciption(){
    const styles = StyleSheet.create({
    
        mainContainerStyle: {
            width: '100%',
            backgroundColor: '#011a39',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: ' center',
            alignItems: 'center',
            gap:'3rem',
            padding:'2rem 0'
        },
        titleStyle: {
            color: '#fec803',
            fontFamily: 'Oswald',
            fontStyle: "bold",
            textAlign: "center",
            fontSize: '2.5rem',
            "@media (min-width: 1024px)": {
                fontSize: "3rem",
                width: '80%',
            }
        },
        generalDescriptionStyle: {
            color: '#F0EFEC',
            textAlign: 'justify',
            fontFamily: "Montserrat",
            width:'80%',
            "@media (min-width: 1024px)": {
                width: '50%',
            }
        }
    })
    return(
        <>
            <div className={css(styles.mainContainerStyle)}>
                <div className={css(styles.titleStyle)}>Durability and Precision in Every Product: Trailers and Welding Solutions Built for Performance</div>
                <div className={css(styles.generalDescriptionStyle)}>At JF Welding, we specialize in providing high-quality trailers and welding products designed to meet the toughest demands across a variety of industries. Whether you're hauling heavy loads, handling intricate welding projects, or looking for custom-built solutions, our products are engineered to deliver exceptional performance, durability, and reliability.</div>
            </div>
        </>
    )
}